import constants from "@/utils/constants";
const appLocation = window.location.origin;

const HUYGENS_MAP_STYLE = "mapbox://styles/vanbram/cloorvods00gg01nz7nyfdjf2";
const DORDRECHT5D_MAP_STYLE =
  "mapbox://styles/vanbram/cke2ieypt0y2m19qobioe29ej";
const CANALS5D_MAP_STYLE = "mapbox://styles/vanbram/ckh82q07q0zy919s7zuh2872c";

const HUYGENS_MAP_BOUNDS = [
  [4.232676, 52.049337],
  [4.431117, 52.130129]
];
const DORDRECHT5D_MAP_BOUNDS = [
  [4.672231, 51.825952],
  [4.625123, 51.803454]
];
const CANALS5D_MAP_BOUNDS = [
  [3.953954722557649, 51.713224059485746],
  [5.180164321137259, 52.24172876058299]
];

const HUYGENS_MAP_CENTER = [4.322062, 52.081942];
const DORDRECHT5D_MAP_CENTER = [4.667576727597634, 51.81536563369278];
const CANALS5D_MAP_CENTER = [4.667927474834781, 52.02205888605782];

export function appIdentifier() {
  if (appLocation == constants.HUYGENS_URL) {
    return constants.HUYGENS;
  }
  if (appLocation == constants.DORDRECHT5D_URL) {
    return constants.DORDRECHT5D;
  }
  if (appLocation == constants.CANALS5D_URL) {
    return constants.CANALS5D;
  }
}

export function appUrl() {
  if (appLocation == constants.HUYGENS_URL) {
    return constants.HUYGENS_URL;
  }
  if (appLocation == constants.DORDRECHT5D_URL) {
    return constants.DORDRECHT5D_URL;
  }
  if (appLocation == constants.CANALS5D_URL) {
    return constants.CANALS5D_URL;
  }
}

export function getMapStyle() {
  if (appLocation == constants.HUYGENS_URL) {
    return HUYGENS_MAP_STYLE;
  }
  if (appLocation == constants.DORDRECHT5D_URL) {
    return DORDRECHT5D_MAP_STYLE;
  }
  if (appLocation == constants.CANALS5D_URL) {
    return CANALS5D_MAP_STYLE;
  }
}

export function getMapBounds() {
  if (appLocation == constants.HUYGENS_URL) {
    return HUYGENS_MAP_BOUNDS;
  }
  if (appLocation == constants.DORDRECHT5D_URL) {
    return DORDRECHT5D_MAP_BOUNDS;
  }
  if (appLocation == constants.CANALS5D_URL) {
    return CANALS5D_MAP_BOUNDS;
  }
}

export function getMapCenter() {
  if (appLocation == constants.HUYGENS_URL) {
    return HUYGENS_MAP_CENTER;
  }
  if (appLocation == constants.DORDRECHT5D_URL) {
    return DORDRECHT5D_MAP_CENTER;
  }
  if (appLocation == constants.CANALS5D_URL) {
    return CANALS5D_MAP_CENTER;
  }
}

export function getMapLineColor() {
  return {
    [constants.HUYGENS_URL]: "#DF7A5F",
    [constants.DORDRECHT5D_URL]: "#358597",
    [constants.CANALS5D_URL]: "#23354E"
  }[appLocation];
}
